import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import logo_img from "./../assets/images/Muvi_Logo_Blue_White.svg";
import moment from 'moment';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class Forgetpassword extends Component {
        constructor(props) {
                super(props);
                var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
                var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
                this.state = {
                        email: '',
                        userAuthKey: has_local_data ? localdata.user_key : '',
                        userId: has_local_data ? localdata.user_id : '',
                        userEmail: has_local_data ? localdata.user_email : '',
                        redirect: false,
                        message: '',
                        fields: {},
                        errors: {},
                        isLoggedIn: false,
                        success_msg: '',
                        // userAuthKey: localStorage.getItem('userAuthKey'),
                        apiUrl: this.decryptconfigdata('apiUrl'),
                }
                this.ForgotPasswordEmail = this.ForgotPasswordEmail.bind(this);
                this.onChange = this.onChange.bind(this);
                this.logout = this.logout.bind(this);
        }

        decryptconfigdata(configkey) {
                var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
                        iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return plaintext;

        }

        decrypt(findresponse, flg) {
                var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var res = flg ? findresponse.encdata : findresponse;
                var bytes = CryptoJS.AES.decrypt(res, key, {
                        iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return JSON.parse(plaintext);
        }

        logout() {
                localStorage.setItem('userLogin', '');
                localStorage.clear();
                < Redirect to={'/login'} />
                window.parent.location = window.parent.location.href;
        }

        handleValidation() {
                let fields = this.state.fields;
                let errors = {};
                let formIsValid = true;
                if (!fields["email"]) {
                        formIsValid = false;
                        errors["email"] = "Please enter  email id.";
                }

                this.setState({ errors: errors });
                return formIsValid;
        }
        ForgotPasswordEmail() {
                
                if (this.handleValidation()) {
                        document.getElementById("reset").disabled = true;
                        fetch(this.state.apiUrl + '/site/ForgetPassword', {

                                method: 'POST',
                                dataType: 'json',
                                body: JSON.stringify(this.state),
                        })
                        
                                .then((response) => response.json())
                                
                                .then((result) => {
                                        result = this.decrypt(result, 1);
                                        console.log(result);
                                        if (result.code == 200) {
                                                this.setState({ success_msg: result.msg, failed_msg:'' });
                                                document.getElementById("reset").disabled = true;
                                        } else if (result.code == 500) {
                                                this.setState({ failed_msg: result.msg, success_msg:'' });
                                                document.getElementById("reset").disabled = false;
                                        }
                                })
                } else {
                        console.log("This Fields Are required.")
                        return false;
                }

        }
        onChange(e) {
                let fields = this.state.fields;
                this.setState({ [e.target.name]: e.target.value });
                fields[e.target.name] = e.target.value;
        }

        componentDidMount() {

        }
        render() {

                return (
                        <div class="limiter" >
                                <div class="logo" >
                                        < a href="#" > < img src={logo_img} /> </a>
                                </div>
                                < div class="container-login100" >
                                        < div class="wrap-login" >
                                                < div class="login100-form validate-form" >
                                                        <form action="javascript:void(0);" onSubmit={() => this.ForgotPasswordEmail()}>
                                                                < span class="login100-form-title" >
                                                                        Forgot Password?
                </span>
                                                                <span class="txt1" >
                                                                        Enter your email address and we will help you get back on track
                </span>
                                                                < div class="wrap-input100" >
                                                                        <input type="text" name="email" class="input100" onChange={this.onChange} />
                                                                 <span class="error">{this.state.errors["email"]}</span>
                                                                        <span  class="error color-sky">{this.state.success_msg}</span>
                                                                        <span  class="error">{this.state.failed_msg}</span>       
                                                                </div>
                                                                <div class="container-login100-form-btn" >
                                                                        <button type="submit" id="reset" class="login100-form-btn btn btn-sky" > Reset Password </button>

                                                                </div>
                                                        </form>

                                                </div>
                                        </div>
                                </div>
                        </div>
                )
        }

}

export default Forgetpassword;



// WEBPACK FOOTER //
// ./src/components/Forgetpassword.js